import {ApplicationAPI} from "../api/ApplicationAPI";

export class ApplicationService {

    private static instance: ApplicationService;
    private applicationAPI: ApplicationAPI;

    private constructor() {
        this.applicationAPI = new ApplicationAPI();
    }

    async getTheme(verificationId: string): Promise<string> {
        return await this.applicationAPI.getApplicationTheme(verificationId)
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new ApplicationService();
        }
        return this.instance;
    }

}